import * as React from "react";
import { PreferredLocale } from "../../../../../../utils/locales";
import { HTMLContent } from "../../../../html-editor/HTMLContent";
import { ICourseLocalizedText } from "../../../../types";
import { AnswerFlex, ListItemsHint } from "../list-items/ListItemsExercisePart.styles";

export interface IAnswerItemProps {
  localizedHint: ICourseLocalizedText | undefined;
  isEditing: boolean;
  currentLocale: PreferredLocale;
  modifyExerciseItemHint: (content: string, locale?: PreferredLocale) => void;
}

export const AnswerItem: React.FC<IAnswerItemProps> = ({
  localizedHint,
  isEditing,
  currentLocale,
  modifyExerciseItemHint,
  children,
}) => (
  <AnswerFlex>
    {(localizedHint || isEditing) && (
      <ListItemsHint>
        <HTMLContent
          content={localizedHint && localizedHint.value.text}
          disabled={!isEditing}
          locale={currentLocale}
          onSubmit={modifyExerciseItemHint}
          placeholder="Click here to add a hint..."
        />
      </ListItemsHint>
    )}
    {children}
  </AnswerFlex>
);
